import data from 'platform/adapter/persistence/service/data'
// import file from 'platform/adapter/persistence/service/file' // can be used instead of cache
import cache from 'platform/adapter/persistence/service/cache'

export {
  data as dataService,
  cache as fileService,
}
